import { Component, Input, OnInit } from '@angular/core';
import { PersonOffDayService } from 'src/app/Service/Person/PersonOffDay.service';


@Component({
  selector: 'app-PersonOffDayView',
  templateUrl: './PersonOffDayView.component.html',
  styleUrls: ['./PersonOffDayView.component.scss']
})
export class PersonOffDayViewComponent implements OnInit {

  @Input() inner_offday_id:number=0

  constructor(
    private Person_Service:PersonOffDayService,

  ) { }

  ngOnInit() {
    this.CheckOffday()
  }

  startDate_fulldate:string=''
  endDate_fulldate:string=''
  replace_person:string=''
  dsc:string=''
  off:number=0
  on:number=0

  CheckOffday(){

    this.Person_Service.GetSingleOffday(this.inner_offday_id).subscribe(
      data=>{


        this.startDate_fulldate=data['startDate_fulldate']
        this.endDate_fulldate=data['endDate_fulldate']
        this.replace_person=data['replace_person']
        this.off=data['off']
        this.on=data['on']
        this.dsc=data['dsc']

      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
        
      }
    )
  }
  

}
